export function getHeatColor(count: number, max: number, isDark = false): string {
  if (count <= 0 || max <= 0) return 'transparent';
  const ratio = Math.min(1, count / max);
  return getHeatLegendColor(ratio, isDark);
}

export function getHeatLegendColor(ratio: number, isDark = false): string {
  const r = Math.max(0, Math.min(1, ratio));
  if (isDark) {
    const l = 14 + 30 * r;
    return `hsl(172 55% ${l}%)`;
  }
  const l = 96 - 48 * r;
  return `hsl(172 58% ${l}%)`;
}

export function isDarkMode(): boolean {
  if (typeof document === 'undefined') return false;
  return document.documentElement.classList.contains('dark');
}

export function getHeatLegendStops(steps = 5): { ratio: number; color: string }[] {
  const dark = isDarkMode();
  return Array.from({ length: steps }, (_, i) => {
    const ratio = i / (steps - 1);
    return { ratio, color: getHeatLegendColor(ratio, dark) };
  });
}
